document.addEventListener("DOMContentLoaded", function () {

  if (document.body.classList.contains("product")) {

    const links = document.querySelectorAll("#product-extra-information a");
    let docLink = null;
    let codeLink = null;
    let forumLink = null;

    links.forEach(link => {
      const text = link.textContent.trim();
      console.log(text);

      if (text.includes("Documentation")) {
        docLink = link;
        link.style.display = "none";
      }

      if (text.includes("Source Code")) {
        codeLink = link;
        link.style.display = "none";
      }

      if (text.includes("Forum")) {
        forumLink = link;
        link.style.display = "none";
      }
    });

    console.log('get',docLink, codeLink, forumLink);

    if (docLink) {
      document.getElementById("docs").innerHTML =
        `<a class="accordion__toggle h6" href="${docLink.getAttribute("href")}">${docLink.innerHTML}</a>`;
        document.getElementById("docs").classList.add('show_exnternal');
    }

    if (codeLink) {
      document.getElementById("code").innerHTML =
        `<a class="accordion__toggle h6" href="${codeLink.getAttribute("href")}">${codeLink.innerHTML}</a>`;
        document.getElementById("code").classList.add('show_exnternal');
    }

    if (forumLink) {
      document.getElementById("forum").innerHTML =
        `<a class="accordion__toggle h6" href="${forumLink.getAttribute("href")}">${forumLink.innerHTML}</a>`;
        document.getElementById("forum").classList.add('show_exnternal');
    } else {
      document.getElementById("forum").style.display = "none";
    }
  }

  document.querySelectorAll('.accc').forEach((input) => {
    input.addEventListener('change', () => {
      const id = input.value;
      const position = input.getAttribute('position');

      const form = document.querySelector('.product-info__block-item product-form .shopify-product-form');

      const qtyField = input.closest('li')?.querySelector('.quantity');

      if (input.checked) {

        if (qtyField) qtyField.value = 1;

        // ID input
        const id_input = document.createElement('input');
        id_input.type = 'hidden';
        id_input.name = `items[${position}][id]`;
        id_input.value = id;
        id_input.classList.add('accessory_item');
        id_input.setAttribute('position', position);

        // Quantity input
        const qty_input = document.createElement('input');
        qty_input.type = 'hidden';
        qty_input.name = `items[${position}][quantity]`;
        qty_input.value = 1;
        qty_input.classList.add('accessory_item','accessory_qty');
        qty_input.setAttribute('position', position);

        form.appendChild(id_input);
        form.appendChild(qty_input);

      } else {

        if (qtyField) qtyField.value = 0;

        const removeItems = document.querySelectorAll(`.accessory_item[position="${position}"]`);
        removeItems.forEach((el) => el.remove());
      }
    });
  });

  document.querySelectorAll('.acccqty').forEach((input) => {
    input.addEventListener('input', () => {
      const qty = parseInt(input.value, 10) || 0;
      const position = input.getAttribute('position');

      const qtyItem = document.querySelector(`.accessory_qty[position="${position}"]`);

      if (qtyItem) {
        qtyItem.value = qty;
      }
    });
  });

});


 